module.exports = __webpack_public_path__ + "img/9.dddb05a9.png";